export default (Component, ...fn) => {
  const fnList = Array.isArray(fn[0]) ? fn[0] : fn;
  return fnList.reduce((acc, curr) => {
    if (typeof curr === 'function') {
      return curr(acc);
    }
    return acc;
  }, Component);
};



// WEBPACK FOOTER //
// ./src/common/utils/composes/index.js